import React, { useState, useEffect } from 'react';
import { APP_API_URL } from '../../../utils';

import axios from 'axios';
import formatNumber, { defaultFilterDates, formatDateWithTime } from '../../../utils/functions';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import OrderLayout from '../../../layout/order-layout';
import Loader from '../../../components/loader';
import UIDropdown from '../../../components/ui/ui-dropdown';
import Swal from 'sweetalert2';

export default function InstallmentOrderVendeur() {
  const user = useSelector((state) => state.auth.user);

  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: 'created_at', direction: 'ascending' });

  const [isOpen, setIsOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState('');
  const [selectedPaiement, setSelectedPaiement] = useState({ label: 'Espèces', value: 4 });
  const [paymentNote, setPaymentNote] = useState('');
  // États pour les filtres
  const [selectedDate, setSelectedDate] = useState('');

  // États pour les données
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(() => defaultFilterDates().dateFrom);
  const [endDate, setEndDate] = useState(() => defaultFilterDates().dateTo);
  const [dateRange, setDateRange] = useState('');
  // États pour les données
  const [allData, setAllData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${APP_API_URL}/installment-orders`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const approvedOrders = response.data.data;
      setData(approvedOrders);
      setAllData(response.data.data);
    } catch (error) {
      console.error('Erreur lors de la récupération des commandes :', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const applyFilters = () => {
    const today = new Date();
    const startOfWeek = getStartOfWeek(today);
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const startOfQuarter = getStartOfQuarter(today);
    const startOfYear = new Date(today.getFullYear(), 0, 1);
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const result = allData.filter(item => {
      const itemDate = new Date(item.created_at);
      const isToday = itemDate.toDateString() === today.toDateString();
      const isYesterday = itemDate.toDateString() === yesterday.toDateString();
      const isThisWeek = itemDate >= startOfWeek && itemDate <= today;
      const isThisMonth = itemDate >= startOfMonth && itemDate <= today;
      const isThisQuarter = itemDate >= startOfQuarter && itemDate <= today;
      const isThisYear = itemDate >= startOfYear && itemDate <= today;

      let matchesDate = false;
      switch (dateRange) {
        case 'today':
          matchesDate = isToday;
          break;
        case 'yesterday':
          matchesDate = isYesterday;
          break;
        case 'this-week':
          matchesDate = isThisWeek;
          break;
        case 'this-month':
          matchesDate = isThisMonth;
          break;
        case 'this-quarter':
          matchesDate = isThisQuarter;
          break;
        case 'this-year':
          matchesDate = isThisYear;
          break;
        default:
          matchesDate = true;
      }

      // Filtrage par plage de dates
      if (startDate && endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);
        end.setHours(23, 59, 59, 999); // Inclure toute la journée
        matchesDate = itemDate >= start && itemDate <= end;
      }

      return matchesDate;
    });

    setFilteredData(result);
    setCurrentPage(1);
  };

  // Fonction pour obtenir le début de la semaine
  const getStartOfWeek = (date) => {
    const day = date.getDay();
    const diff = date.getDate() - day; // Dimanche comme premier jour de la semaine
    const startOfWeek = new Date(date);
    startOfWeek.setDate(diff);
    startOfWeek.setHours(0, 0, 0, 0);
    return startOfWeek;
  };

  // Fonction pour obtenir le début du trimestre
  const getStartOfQuarter = (date) => {
    const quarterStartMonth = Math.floor(date.getMonth() / 3) * 3;
    const startOfQuarter = new Date(date.getFullYear(), quarterStartMonth, 1);
    startOfQuarter.setHours(0, 0, 0, 0);
    return startOfQuarter;
  };

  useEffect(() => {
    const result = data.filter(item =>
      item.designation.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setFilteredData(result);
    setCurrentPage(1);
  }, [searchTerm, data]);

  const sortedItems = [...filteredData].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === 'ascending' ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === 'ascending' ? 1 : -1;
    }
    return 0;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedItems.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedItems.length / itemsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }

    const sortedData = [...filteredData].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === 'ascending' ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });

    setSortConfig({ key, direction });
    setFilteredData(sortedData);
  };

  const handleAddPayment = async () => {
    if (!selectedOrder || !paymentAmount) return;

    try {
      const token = localStorage.getItem('token');
      await axios.post(`${APP_API_URL}/installment-orders/${selectedOrder.id}/payments`, {
        amount: parseFloat(paymentAmount),
        user_id: user.id,
        payment_method: selectedPaiement.label,
        notes: paymentNote,
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      document.getElementById('dismissPaymentModal').click();

      setPaymentAmount('');
      fetchData(); // rafraîchir les données

      // ✅ Message de succès
      await Swal.fire({
        icon: 'success',
        title: 'Paiement ajouté avec succès',
        showConfirmButton: false,
        timer: 1500,
      });

      // ✅ Redirection (vers la page de la commande)
      // navigate(`/commande/${selectedOrder.id}`);

    } catch (error) {
      console.error('Erreur lors de l’ajout du paiement :', error);

      // ❌ Message d'erreur
      Swal.fire({
        icon: 'error',
        title: 'Erreur',
        text: "Une erreur s'est produite lors de l'ajout du paiement.",
      });
    }
  };

  const handleRefresh = async () => {
    await fetchData();
    setCurrentPage(1);
  };

  const handlePaiementSelect = (option) => {
    setSelectedPaiement(option);
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <OrderLayout>
      <div className="mx-auto w-full min-h-full max-w-6xl bg-white p-4 sm:p-6 lg:p-8">
        <div className='flex flex-col lg:flex-row lg:justify-between lg:items-center mb-16'>
          <div className="pagetitle">
            <h1>Ventes</h1>
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item active">Gérer vos ventes</li>
              </ol>
            </nav>
          </div>

          <div className='flex flex-col lg:flex-row gap-x-2 gap-y-4'>
            <div className='flex flex-row gap-x-2'>
              <button title='Rafraichir' onClick={handleRefresh} type="button" className="inline-flex items-center border rounded-md bg-gray-50 px-2.5 py-2 text-sm font-semibold text-gray-950 hover:bg-gray-300 transition-all duration-300">
                <i className="bi bi-arrow-clockwise"></i>
              </button>
            </div>
          </div>
        </div>

        <section className='section'>
          <div className="card mb-4">
            <div className="card-header pb-4">
              <div className="row justify-content-between">
                <div className="col-md-10 flex flex-row gap-x-4">
                  <div className=''>
                    <label htmlFor="searchInput" className="form-label">
                      Rechercher
                    </label>
                    <input
                      id="searchInput"
                      type="search"
                      className="form-control"
                      placeholder="Rechercher..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>

                <div className="flex items-center justify-end gap-x-2 col-lg-2 col-md-6 mt-3 mt-md-0">
                  <button
                    type="button"
                    title='Options de filtrage'
                    onClick={toggleAccordion}
                    className={`inline-flex items-center border rounded-md px-3 py-2 text-sm font-semibold hover:bg-gray-300 transition-all duration-300 ${isOpen ? 'bg-red-500 text-white' : 'bg-gray-50 text-gray-950'}`}
                  >
                    <i className={`bi ${isOpen ? 'bi-x-lg' : 'bi-funnel-fill'}`}></i>
                  </button>
                </div>
              </div>

              <div className="accordion" id="accordionExample">
                <div className="accordaion-item">
                  <div className={`transition-max-height duration-300 ease-in-out overflow-hidden ${isOpen ? 'md:max-h-20' : 'max-h-0'}`}>
                    <div className="accordion-body px-0 border-t my-4">
                      <form className="row g-3">
                        <div className="col-md-8">
                          <div className="row">
                            <div className="col-md-3">
                              <input
                                type="date"
                                className="form-control"
                                placeholder="Date de début"
                                value={startDate}
                                onChange={e => setStartDate(e.target.value)}
                              />
                            </div>
                            <div className="col-md-3">
                              <input
                                type="date"
                                className="form-control"
                                placeholder="Date de fin"
                                value={endDate}
                                onChange={e => setEndDate(e.target.value)}
                              />
                            </div>
                            <div className="col-md-3">
                              <select
                                className="form-select"
                                value={dateRange}
                                onChange={e => setDateRange(e.target.value)}>
                                <option value="">Plage de dates</option>
                                <option value="today">Aujourd'hui</option>
                                <option value="yesterday">Hier</option>
                                <option value="this-week">Cette semaine</option>
                                <option value="this-month">Ce mois</option>
                                <option value="this-quarter">Ce trimestre</option>
                                <option value="this-year">Cette année</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="flex justify-end">
                            <button
                              type="button"
                              onClick={applyFilters}
                              className="inline-flex items-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 transition-all duration-300">
                              <i className="bi bi-search me-1" /> Recherche
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card-body p-0 printable print:w-full">
              <div className="table-responsive table-card">
                <table className="table text-nowrap mb-0 table-centered table-hover">
                  <thead className="table-light">
                    <tr>
                      <th className="ps-3">
                        <button
                          className="inline-flex items-center justify-between w-full"
                          onClick={() => requestSort('designation')}
                          aria-label="Trier par référence"
                        >
                          Référence
                          <i className="bi bi-arrow-down-up text-gray-400"></i>
                        </button>
                      </th>
                      <th>
                        <button
                          className="inline-flex items-center justify-between w-full"
                          onClick={() => requestSort('total_amount')}
                          aria-label="Trier par montant TTC"
                        >
                          Montant TTC
                          <i className="bi bi-arrow-down-up text-gray-400"></i>
                        </button>
                      </th>
                      <th>
                        <button
                          className="inline-flex items-center justify-between w-full"
                          onClick={() => requestSort('total_paid')}
                          aria-label="Trier par montant payé"
                        >
                          Montant Payé
                          <i className="bi bi-arrow-down-up text-gray-400"></i>
                        </button>
                      </th>
                      <th>
                        <button
                          className="inline-flex items-center justify-between w-full"
                          onClick={() => requestSort('remaining_amount')}
                          aria-label="Trier par montant dû"
                        >
                          Montant Dû
                          <i className="bi bi-arrow-down-up text-gray-400"></i>
                        </button>
                      </th>
                      <th>
                        <button
                          className="inline-flex items-center justify-between w-full"
                          onClick={() => requestSort('payment_count')}
                          aria-label="Trier par nombre de paiements"
                        >
                          Nbr de Paiements
                          <i className="bi bi-arrow-down-up text-gray-400"></i>
                        </button>
                      </th>
                      <th>
                        <button
                          className="inline-flex items-center justify-between w-full"
                          onClick={() => requestSort('last_payment_date')}
                          aria-label="Trier par dernier paiement"
                        >
                          Dernier Paiement
                          <i className="bi bi-arrow-down-up text-gray-400"></i>
                        </button>
                      </th>
                      <th>
                        <span>Action</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.length > 0 ? (
                      currentItems.map((item) => (
                        <tr key={`commande-${item.id}`} className="align-middle">
                          <td className="ps-3 font-semibold">{item.designation || 'N/A'}</td>
                          <td>{formatNumber(item.total_amount) || '0'} FCFA</td>
                          <td>{formatNumber(item.total_paid) || '0'} FCFA</td>
                          <td className="font-semibold">{formatNumber(item.remaining_amount) || '0'} FCFA</td>
                          <td>
                            <span className="badge bg-info">{item.payment_count || 0}</span>
                          </td>
                          <td>
                            {item.last_payment?.created_at
                              ? formatDateWithTime(item.last_payment.created_at)
                              : 'Aucun paiement'}
                          </td>
                          <td style={{ whiteSpace: 'normal' }}>
                            <Link
                              to={`/installment-orders/${item.id}`}
                              title="Modifier"
                              className="btn btn-ghost btn-icon btn-xs rounded-xl texttooltip border mr-2"
                            >
                              <i className="bi bi-printer"></i>
                            </Link>

                            <button
                              className="btn btn-primary btn-icon btn-xs rounded-xl texttooltip border mr-2"
                              data-bs-toggle="modal"
                              data-bs-target="#paymentModal"
                              onClick={() => setSelectedOrder(item)}
                            >
                              <i className="bi bi-plus-circle me-1"></i> Paiement
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="datatable-empty" colSpan="7">
                          Aucune commande correspondant aux critères de recherche.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="card-footer d-md-flex justify-content-between align-items-center">
              <span>
                {currentItems.length > 0
                  ? `Affichage de ${Math.max(indexOfFirstItem + 1, 0)} à ${Math.min(indexOfLastItem, currentItems.length)} sur ${sortedItems.length} entrée${sortedItems.length > 1 ? 's' : ''}`
                  : `Aucune entrée à afficher`}
                {currentItems.length === 0 && data.length > 0 && ` (filtré à partir de ${data.length} entrée${data.length > 1 ? 's' : ''} totales)`}
              </span>

              {currentItems.length > 0 && (
                <nav className="mt-2 mt-md-0">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <a className="page-link" href="#!" onClick={handlePrevPage} disabled={currentPage === 1}>
                        Précédent
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#!" onClick={handleNextPage} disabled={currentPage === totalPages}>
                        Suivant
                      </a>
                    </li>
                  </ul>
                </nav>
              )}
            </div>
          </div>
        </section>
      </div>

      {/* Modal Ajouter Paiement */}
      <div className="modal fade" id="paymentModal" tabIndex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="paymentModalLabel">Ajouter un Paiement</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label htmlFor="paymentAmount" className="form-label">Montant à payer</label>
                <input
                  type="number"
                  className="form-control"
                  id="paymentAmount"
                  value={paymentAmount}
                  onChange={(e) => setPaymentAmount(e.target.value)}
                />
              </div>
              <div className='mb-3'>
                <label htmlFor='name' className='form-label text-gray-950'>
                  Méthode de paiement
                </label>
                <UIDropdown
                  options={[
                    { label: 'Mobile Money', value: 1 },
                    { label: 'Carte bancaire', value: 2 },
                    { label: 'Virement', value: 3 },
                    { label: 'Espèces', value: 4 },
                    { label: 'Crédit', value: 5 },
                    { label: 'Chèques', value: 7 },
                    { label: 'Autre', value: 6 },
                  ]}
                  selectedOption={selectedPaiement}
                  onSelect={handlePaiementSelect}
                  enableSearch={true}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="paymentNote" className="form-label">Note (optionnelle)</label>
                <textarea
                  className="form-control"
                  id="paymentNote"
                  rows="3"
                  value={paymentNote}
                  onChange={(e) => setPaymentNote(e.target.value)}
                  placeholder="Ajouter une remarque ou un commentaire"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" id='dismissPaymentModal'>Annuler</button>
              <button type="button" className="btn btn-primary" onClick={handleAddPayment}>Valider</button>
            </div>
          </div>
        </div>
      </div>
    </OrderLayout>
  );
};
